import { CLEAR_DATA } from "commons/src/reducers/indexActions";
import { STOP_IMPERSONATING_CLIENT } from "commons/src/reducers/clientPortalUserActions";
import { REACT_NATIVE } from "commons/src/reducers/indexActions";

const getInitialWebApplicationState = state => {
    return state?.applicationContext
        ? {
              applicationContext: {
                  isLoading: state?.applicationContext?.isLoading ?? false,
                  isError: false,
                  msg: state?.applicationContext?.msg ?? "",
                  msgSeverity: state?.applicationContext?.msgSeverity ?? "INFO",
                  errorCode: state?.applicationContext?.errorCode ?? null,
                  failedLogIn: state?.applicationContext?.failedLogIn ?? false
              }
          }
        : {};
};

const getInitialNativeApplicationState = (state, isAdviser) => {
    const sessionDetails = isAdviser ? state.application?.sessionDetails : {};
    return state?.application
        ? {
              application: {
                  availableAuthTypes: state.application.availableAuthTypes ?? [],
                  isFirstLaunch: state.application.isFirstLaunch,
                  loginPreference: state.application.loginPreference ?? null,
                  userHasLoggedOut: isAdviser ? false : true,
                  sessionDetails: { ...sessionDetails },
                  systemMaintenance: state.application.systemMaintenance ?? false,
                  biometricSetupStatus: state.application.biometricSetupStatus ?? "",
                  initialPath: state.application.initialPath ?? "",
                  message: {
                      key: state.application?.message?.key ?? "",
                      location: state.application.message?.location ?? ""
                  }
              }
          }
        : {};
};

const getInitialState = state => {
    const webNavigation = state?.navigation ? { navigation: { path: "" } } : {};
    return {
        user: {
            isLoggedIn: false,
            preferences: { adHocFeeAuth: {}, correspondenceDelivery: {} }
        },
        ...getInitialWebApplicationState(state),
        ...getInitialNativeApplicationState(state),
        ...webNavigation
    };
};

const getAdviserInitialState = state => {
    const initialState = getInitialState();

    return {
        ...initialState,
        ...getInitialNativeApplicationState(state, true),
        ...getInitialWebApplicationState(state),
        user: {
            ...initialState.user,
            adviserId: state.user.adviserId,
            adviserRoles: state.user.adviserRoles,
            termsAccepted: true,
            username: state.user.username,
            isLoggedIn: true,
            selection: {
                locationId: state.adviser?.adviser?.location?.locationId ?? null
            }
        }
    };
};

export const getRootReducer = combinedReducers => {
    return (state = {}, action) => {
        if (!state.user?.isLoggedIn) {
            return combinedReducers(getInitialState(state), action);
        }

        if (action.type === STOP_IMPERSONATING_CLIENT) {
            return combinedReducers(getAdviserInitialState(state), action);
        }

        if (action.type === CLEAR_DATA) {
            const passedState =
                action.agent === REACT_NATIVE ? { application: state.application } : {};
            return combinedReducers(getInitialState(passedState), action);
        }

        return combinedReducers(state, action);
    };
};
